import { useSelector } from "react-redux";

const useLoggedUserInfo = () => {
  return useSelector(({ auth }) => auth.user);
};

export default useLoggedUserInfo;
